<template>
  <v-app>
    <v-container class="main">
      <!-- PCレイアウト -->
      <div v-if="$vuetify.breakpoint.mdOnly || $vuetify.breakpoint.lgOnly || $vuetify.breakpoint.xlOnly">
        <HeaderPC/>
        <TopWrapperPC :status="status"/>
      </div>
      <!-- スマホ/タブレットレイアウト -->
      <div v-else>
        <HeaderSP/>
        <TopWrapperSP :status="status"/>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import TopWrapperPC from './TopWrapperPC'
import HeaderPC from './HeaderPC'
import TopWrapperSP from './TopWrapperSP'
import HeaderSP from './HeaderSP'

export default {
  props: {
    status: Number,
  },
  components: {
    TopWrapperPC,
    HeaderPC,
    TopWrapperSP,
    HeaderSP
  }
}
</script>

<style lang="scss" scoped>
.main{
  color: #F1FAEE;
}
.container {
  width: 100%;
  max-width: none;
  margin: 0px;
  padding: 0px;
}
</style>
